export default __webpack_public_path__ + "static/media/Snd_TryF.edb7bdc8.mp3";